import React, { useEffect, useState } from 'react';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { BaseTypography } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import ImageOrVideo from '../../components/common/ImageOrVideo/ImageOrVideo';
import { Grid } from '@material-ui/core';
import { GuestDiscuss } from '../newsBlock/GuestDiscuss';
import { getFullName } from '../../utils/helpers';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import backArrow from '../../assets/images/back-arrow.png';
import timeIcon from '../../assets/icons/time-icon.svg';
import locationIcon from '../../assets/icons/up-location-icon.svg';
import dateIcon from '../../assets/icons/date-icon.svg';
import organiseIcon from '../../assets/images/organise-icon.png';
import "./EventsNew.css";
import FsLightbox from "fslightbox-react";

type PInterviewCarousel = {
    list: any;
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '60px 20px'
    },
    image:{
        maxWidth: '100% !important',
        '& iframe, video': {
            maxWidth: '100% !important',
          },
    },
	backimage:{
		width: '8px',
		height: 'auto',
		marginRight: '6px',
	},
    text: {
        margin: "20px 0 10px"
    },
    expertise: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    website:{
        margin: "20px 0 10px"
    },
	backlink: {
		color: '#0073C9',
		display: 'flex',
		alignItems: 'center',
		marginBottom: '15px',
	},
	eventsItem: {
		display: 'flex',
		gap: "10px",
		'@media (max-width:1024px)': {
			display: 'block',
		}
	},
	eventsItemLeft: {
		width: '50%',
		'& img': {
			width: '100%',
			height: 'auto',
		},
		'@media (max-width:1024px)': {
			width: '100%',
			marginBottom: '30px',
		},
		'& h2': {
			marginTop: '50px',
			fontSize: '24px',
			fontWeight: '600',
		},
		'@media (min-width:769px)': {
			'& img': {
				width: '100%',
				objectFit: 'cover',
			},
			'& video': {
				width: '100% !important',
				height: '175px !important',
			}
		}
	},
	eventsItemRight: {
		width: '50%',
		'@media (max-width:1024px)': {
			width: '100%',
		},
		'& h2': {
			fontSize: '24px',
			fontWeight: '600',
		}
	},
	eventsDetailContainer: {
		border: '1px solid #C5C5C5',
		padding: '0px 30px',
		'@media (min-width:1024px)': {
			padding: '48px 30px',
		},
	},
	eventsDetails: {
		width: '100% !important',
		display: 'grid',
	    gridTemplateColumns: 'repeat(2, 1fr)',
	    gridColumnGap: '15px',
	    gridRowGap: '15px',
		'@media (max-width:680px)': {
		  gridTemplateColumns: 'repeat(1, 1fr)',
		},
		'& h5': {
            fontSize: '18px',
			fontWeight: '500',
			marginBottom: '0',
        },
		'& h4': {
			fontSize: '20px',
			marginTop: '15px',
		},
	},  
	icon: {
		width: '24px',
		height: '24px',
		marginRight: '10px',
		verticalAlign: 'middle',
	},
	iconorganise: {
		width: '21px',
		height: '26px',
		marginRight: '10px',
		verticalAlign: 'middle',
	},
	contactDetails: {
		'@media (min-width:1024px)': {
			paddingLeft: '40px',
		},
		'& h2': {
			marginTop: '14px',
		},
		'& h5': {
			fontSize: '18px',
			marginBottom: '0',
			fontWeight: '500',
		},
		'& p': {
			fontSize: '16px',
			marginTop: '8px',
			color: '#0073C9',
		},
	},
	expertsDetails: {
		'@media (min-width:1024px)': {
			paddingLeft: '40px',
		},
		margin: '50px 0',
		'& p': {
			fontSize: '14px',
			fontWeight: '500',
			lineHeight: '18px',
		}
	},
	expertslist: {
		display: 'inline-block',
		width: '130px',
		verticalAlign: 'top',
		marginRight: '15px',
		marginBottom: '10px',
		'& img': {
			width: '48px',
			height: '48px',
			borderRadius: '50%'
		},
		'& video': {
			width: '48px !important',
			height: '48px !important',
			borderRadius: '50% !important',
			margin: '0 0 14px 0 !important',
		}
	},
	eventsTop: {
		'@media (min-width:1024px)': {
			display: 'flex',
			gap: '20px',
			'& >div': {
				width: '50%',
				margin: '5px',
			}
		}
	},
	eventsImgBlock: {
		'& img': {
			width: '100%',
			height: '100%',
		}
	},
	eventsDetail: {
		border: '1px solid #C5C5C5',
		padding: '30px 30px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		'@media (max-width:1023px)': {
			marginTop: '10px',
		}
	},
	expertsDetailsInner: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '15px',
		'& > div': {
			minWidth: '280px',
			width: '280px',
			padding: '5px 20px',
		},
		'& button': {
			width: '100px',
		},
	},
	
}));


export const Post: React.FC<PInterviewCarousel> = (props) => {
    const { list } = props;
    const commonClasses = useCommonStyles();
    const classes = useStyles();    

    useEffect(() => {
    }, [list])
	
	const tConvert = (e:any) => {
      // Check correct time format and split into components
      let time = e.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [e];
      if (time.length > 1) { // If time format correct
			time = time.slice (1);  // Remove full string match value
			time[3] = '';
			time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
			time[0] = +time[0] % 12 || 12; // Adjust hours
	  }
	  return time.join (''); // return adjusted time or original string
	}
  
	const imageData = JSON.parse(list?.data.header_image_json || '');
	
	const [toggler, setToggler] = useState(false);
	const img_arr = [];
	const type_arr = [];
	if(list?.data?.medias !== null) {
		list?.data?.medias.map((p) => {
			return (
				img_arr.push(`${process.env.REACT_APP_API_URL}/storage/${p.file}`),
				type_arr.push(p.type)
			)
		})
	}
	
	const [lightboxController, setLightboxController] = useState({
		toggler: false,
		slide: 1
	});
	
	function openLightboxOnSlide(number) {
		setLightboxController({
			toggler: !lightboxController.toggler,
			slide: number
		});
	}
	
    return (
        <div className={`${commonClasses.container} ${classes.root}`}>
            <BaseTypography style={{ marginBottom: '30px', fontSize: '40px', lineHeight: '52px', fontWeight: '500' }} gutterBottom="true" variant="h2">{list?.data?.heading}</BaseTypography>
			<div className={classes.eventsTop}>
				<div className={classes.eventsImgBlock}>
					{list?.data?.header_image && (
							<ImageOrVideo className={classes.image} src={list?.data.header_image ? imageData?.[0]?.url : `${process.env.REACT_APP_API_URL}/images/dummy-blog-img.jpg`} alt={list?.data.header_image} width="100% !important"/>
					)}
				</div>
				<div className={classes.eventsDetail}>
					<div className={classes.eventsDetails}>
						<div className={classes.dateContent}>
							<h5><ImageOrVideo src={dateIcon} alt="DATE ICON" className={classes.icon}/>Date</h5>
							<h4>{new Date(list?.data.start_date).toDateString().split(" ").splice(0, 4).join(" ")} {list?.data.start_date !== list?.data.end_date ?  `- ${new Date(list?.data.end_date).toDateString().split(" ").splice(0, 4).join(" ")}` : ''}</h4>
						</div>
						<div className={classes.dateContent}>
							<h5><ImageOrVideo src={timeIcon} alt="TIME ICON" className={classes.icon}/>Time</h5>
							<h4>{list?.data.all_day === 0 ? `${tConvert(list?.data.start_time)} - ${tConvert(list?.data.end_time)}` : 'All Day'}</h4>
						</div>	
					</div>
					<div className={classes.eventsDetails}>
						<div className={classes.dateContent}>
							<h5><ImageOrVideo src={locationIcon} alt="LOCATION ICON" className={classes.icon}/>Venue</h5>
							<h4>{list?.data?.location}</h4>
						</div>
						<div className={classes.dateContent}>
							<h5><ImageOrVideo src={organiseIcon} alt="ORGANISE ICON" className={classes.iconorganise}/>Organised by</h5>
							<h4>{list?.data?.organised_by}</h4>
						</div>	
					</div>
				</div>
			</div>
			<div className={classes.eventsItem}>
				<div className={classes.eventsItemLeft}>
					{list?.data.description && (
						<h2>About the Event</h2>
					) }
					{list?.data.description && (
						<BaseTypography className={classes.text} dangerouslySetInnerHTML={{ __html :list?.data.description}} /> 	
					) }
					{list?.data?.media?.length > 0 && (
						<h2>Gallery</h2>
					  )}
					<Grid container spacing={1}>
						{list?.data?.medias !== null
						? list?.data?.medias?.map((items,i) => {
							return (
							<Grid item xs={12} md={6}>
							  <div className={classes.blockImages}>
								{' '}
								<div>
									<div onClick={() => openLightboxOnSlide(i+1)}>
										<ImageOrVideo src={`${process.env.REACT_APP_API_URL}/storage/${items.file}`} alt="Gallery" />
									</div>{' '}
								</div>
							  </div>
							</Grid>  
							);
						  })
						: null}
					</Grid>
				</div>
				<div className={classes.eventsItemRight}>
					<div className={classes.expertsDetails}>
						{list?.data?.guests?.length > 0 && (
							<h2>Experts</h2>
						)}
						{/* {list?.data?.guests !== null
						? list?.data.guests.map((items: any) => {
							return (
								<div className={classes.expertslist}>
								  <ImageOrVideo src={items.avatar ? `${process.env.REACT_APP_API_URL}/storage/${items.avatar}` : `https://contactsbook.media/static/media/no-user-picture.ccbb6964.svg`}  alt="avatar" />
								  <p>{items.first_name} {items.last_name}</p>
								</div>
								
							);
						  })
						: null} */}
						<div className={classes.expertsDetailsInner}>
							{list?.data.guests?.map((guest: any) => (
								<GuestDiscuss
									key={guest.guest_id}
									avatarSrc={guest.avatar}
									guestId={guest.guest_id}
									fullName={getFullName(guest)}
								/>
							))}
						</div>
					</div>
					<div className={classes.contactDetails}>
						<h2>Contact Details</h2>
						{list?.data?.phone_number && (
								<h5>Phone Number</h5>
							)
						}
						<p><a style={{textDecoration: 'none'}} href={`tel:${list?.data?.phone_number}`}>{list?.data?.phone_number}</a></p>
						{list?.data?.email && (
								<h5>Email</h5>
							)
						}
						<p><a style={{textDecoration: 'none'}} href={`mailto:${list?.data?.email}`}>{list?.data?.email}</a></p>
						{list?.data?.signups_url && (
						<h5>Website URL</h5>)}
						{list?.data?.signups_url && (
						<p><a style={{textDecoration: 'none', wordWrap: 'break-word'}} target="__blank" href={list?.data?.signups_url}>{list?.data?.signups_url}</a></p>)}
						{list?.data?.industries?.length > 0 && (
							<h5>Industries</h5>)}
						<p>{list?.data?.industries !== null
						? list?.data.industries.map(industry => industry.name).join(', ')
						: null}</p>
					</div>
				</div>
				<FsLightbox
					toggler={lightboxController.toggler}
					sources={img_arr}
					slide={lightboxController.slide}
					type="image"
					types={type_arr}
				/>
			</div>
        </div>
    )
}